function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.8,11.9l-0.3-0.1l-0.2-0.2l-0.2-0.3L2,11V9.9c0-0.7,0.2-1.4,0.4-2c0.3-0.6,0.7-1.1,1.2-1.6c0.5-0.4,1.1-0.8,1.8-1.1 C6.1,5,6.8,4.9,7.6,4.8l1.6-0.1l1.6-0.1l1.8-0.1l1.6,0.1l1.3,0.1l1.2,0.2c0.8,0.1,1.4,0.3,2.1,0.6c0.7,0.3,1.2,0.7,1.8,1.1 c0.5,0.4,0.9,0.9,1.1,1.6c0.3,0.6,0.4,1.2,0.4,2v1.1l-0.1,0.3l-0.2,0.3l-0.3,0.2l-0.3,0.1h-3.3l-0.3-0.1l-0.2-0.2l-0.2-0.3l-0.1-0.3 V8.8l-0.1-0.4l-0.2-0.3l-0.3-0.2c-0.1-0.1-0.2-0.1-0.4-0.1h-8c-0.1,0-0.2,0.1-0.4,0.1L7.3,8.1L7.1,8.4C7,8.5,7,8.6,7,8.8V11 l-0.1,0.4l-0.2,0.3l-0.3,0.2l-0.3,0.1H2.8L2.8,11.9z M10.6,12.6h2.6v4.8l2-2v2.6l-3.3,3.5l-3.3-3.5v-2.6l2,2L10.6,12.6L10.6,12.6z"
});

function SvgLeaveMeeting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveMeeting);
export default __webpack_public_path__ + "static/media/LeaveMeeting.29a308cf.svg";
export { ForwardRef as ReactComponent };